export const clearTaggingTitle = (title: string) =>
  title
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\w\s]/gi, '')
    .replace(/[\u{1F600}-\u{1F64F}]/gu, '')
    .trim()
